module.exports = __webpack_public_path__ + "static/img/19.162c27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/19.png
// module id = 42QL
// module chunks = 1